<div class="login-container">
    <div class="login-wrapper">
        <div class="login-left">
        </div>
        <div class="login-right">
            <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage !== undefined && errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                <span>{{error}}</span>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="logo">
                <span class="logo-text">INVOICEX</span>
            </div>
            <form class="theme-form">
                <div class="alert alert-danger alert-dismissible fade show" role="alert" v-if="errorMessage !== undefined && errorMessage.length > 0" v-for="(error, key) in errorMessage" :key="error">
                    <span>{{error}}</span>
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="removeError(key)">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="form-group">
                    <InputTextNormal
                            :label="dataLogin.user_email.label"
                            :id="dataLogin.user_email.id"
                            :placeholder="dataLogin.user_email.placeholder"
                            :value-default="dataLogin.user_email.value"
                            @inputValue="onChange($event, dataLogin.user_email.id)"
                            :error-text="dataLogin.user_email.error"
                            :is-error="dataLogin.user_email.isError"
                            @blur="validateLogin($event, dataLogin.user_email.id)"
                            :required="dataLogin.user_email.required"
                    ></InputTextNormal>
                </div>
                <div class="form-group mt-2">
                    <InputPasswordNormal
                            :label="dataLogin.user_password.label"
                            :id="dataLogin.user_password.id"
                            :placeholder="dataLogin.user_password.placeholder"
                            :value-default="dataLogin.user_password.value"
                            @inputValue="onChange($event, dataLogin.user_password.id)"
                            :error-text="dataLogin.user_password.error"
                            :is-error="dataLogin.user_password.isError"
                            @blur="validateLogin($event, dataLogin.user_password.id)"
                            :required="dataLogin.user_password.required"
                    ></InputPasswordNormal>
                </div>
                <div class="form-group mb-0 d-flex justify-content-between align-items-center">
                    <div class="checkbox p-0">
                        <InputCheckboxOne
                                :id="dataLogin.keepPassword.id"
                                :label="dataLogin.keepPassword.label"
                                :valueInput="dataLogin.keepPassword.valueInput"
                        ></InputCheckboxOne>
                    </div>
                    <a class="link forgot-password" href="javascript:void(0)">Quên mật khẩu?</a>
                </div>
                <div class="text-end mt-3">
                    <ButtonLoginComponent
                            :label="'Đăng nhập'"
                            @click="submitLogin"
                    ></ButtonLoginComponent>
                </div>
                <p class="mt-4 mb-0 text-center">
                    Bạn chưa có tài khoản?<RouterLink style="color: #696cff" :to="{path:'register'}">Tạo tài khoản ở đây.</RouterLink>
                </p>
            </form>
        </div>
    </div>
</div>

